import React from "react";
import AnimateLine from "../../common/AnimateLine";
import AboutArea from "../home/AboutArea";
import FeaturesArea from "../home/FeaturesArea";
import HistoryArea from "./HistoryArea";

function AboutWrap() {
  return (
    <>
      <div style={{ marginTop: "120px" }} className="digital-shifts-wrap">
        <AnimateLine />
        {/* <WhyChooseUs /> */}
        <AboutArea image="/img/logods.png" />
        <FeaturesArea />
        <HistoryArea />
        {/* <Testimonial/> */}
        {/* <TeamWrap/> */}
        {/* <LatesPost/> */}
      </div>
    </>
  );
}

export default AboutWrap;
